import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export interface OutcomeChip {
  key: string;
  label: string;
}

/** The dialog answers the flow switched on for the outcome card, in the order they were asked. */
export default function OutcomeChips({ chips }: { chips: OutcomeChip[] }) {
  return (
    <Stack direction='row' sx={{ mb: 0.5, gap: 0.5, flexWrap: 'wrap' }}>
      {chips.map(({ key, label }) => (
        <Chip
          key={key}
          label={label}
          sx={{ width: 'fit-content', backgroundColor: 'secondary.main', color: 'white' }}
        />
      ))}
    </Stack>
  );
}
